<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter">
<span epub:type="pagebreak" id="p32" title="32">
<h2 class="recipetitle" id="cheesy_sausage_and_egg_bake">Cheesy Sausage and Egg Bake</h2>
<p class="recipetime"><span class="yield_black">12 servings</span> <span class="separater">|</span> Prep Time: 25 Minutes <span class="separater">|</span> Start to Finish: 1 Hour</p>
<p class="dot">•••</p>
<ul class="ingredient">
<li class="list"><span class="qty1">1</span> lb bulk pork sausage</li>
<li class="list"><span class="qty1">1½</span> cups sliced fresh mushrooms (4 oz)</li>
<li class="list"><span class="qty1">8</span> medium green onions, sliced (½ cup)</li>
<li class="list"><span class="qty1">2</span> medium tomatoes, chopped (1½ cups)</li>
<li class="list"><span class="qty1">2</span> cups shredded mozzarella cheese (8 oz)</li>
<li class="list"><span class="qty1">1¼</span> cups Original Bisquick mix</li>
<li class="list"><span class="qty1">1½</span> teaspoons salt</li>
<li class="list"><span class="qty1">1½</span> teaspoons chopped fresh or ½ teaspoon dried oregano leaves</li>
<li class="list"><span class="qty1">½</span> teaspoon pepper</li>
<li class="list"><span class="qty1">1</span> cup milk</li>
<li class="list"><span class="qty1">12</span> eggs</li>
</ul>
<p class="recipeprocedure"><span class="stepnum">1</span> Spray 13x9-inch (3-quart) glass baking dish with cooking spray. In 10-inch skillet, cook sausage over medium-high heat 5 to 7 minutes, stirring occasionally, until no longer pink; drain.</p>
<p class="recipeprocedure"><span class="stepnum">2</span> In baking dish, layer sausage, mushrooms, onions, tomatoes and cheese.</p>
<p class="recipeprocedure"><span class="stepnum">3</span> In large bowl, stir remaining ingredients with whisk or fork until blended. Pour over ingredients in baking dish.</p>
<p class="recipeprocedure"><span class="stepnum">4</span> Cover baking dish tightly. Refrigerate up to 24 hours.</p>
<p class="recipeprocedure"><span class="stepnum">5</span> Heat oven to 350°F. Uncover baking dish. Bake 30 to 35 minutes or until golden brown and set.</p>
<p class="recipe_info"><span class="nutr_bold">1 Serving:</span> Calories 260; Total Fat 16g (Saturated Fat 6g, Trans Fat 0.5g); Cholesterol 240mg; Sodium 750mg; Total Carbohydrate 12g (Dietary Fiber 0g); Protein 17g <span class="nutr_bold">Exchanges:</span> 1 Starch, 2 High-Fat Meat <span class="nutr_bold">Carbohydrate Choices:</span> 1</p>
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p032.vue?029b222a